module.exports = __webpack_public_path__ + "Physical-688ceccb7582be9104621da512779700.png";